'use strict';

var coreUtilityAliases = require('../../common/var/coreUtilityAliases');

var getOwn = coreUtilityAliases.getOwn;

function getCollationCharacter(str, index, sortEquivalents) {
  var chr = str.charAt(index);
  return getOwn(sortEquivalents, chr) || chr;
}

module.exports = getCollationCharacter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/internal/getCollationCharacter.js
// module id = 752
// module chunks = 1